import TaskRunner from '../base/TaskRunner';
import Rellax from 'rellax';

TaskRunner.add(() => {
    if(Rellax){
        document.querySelectorAll('.rellax').forEach(itm => {
            const rel = new Rellax(itm);
        });
    }
});